import { $ValueModuleName } from "@omni/types/utils/store";
import { hasWindow } from "@omni/utils/dom.utils";
import { isArray } from "@omni/utils/type.utils";
import { merge } from "lodash-es";
import { Reducer } from "redux";

import { IValueState, TValueAction } from "./store.types";
import { createConstants } from "./utils";

export enum VALUE_STAGES {
    Init = "INIT",
    Reset = "RESET",
    Set = "SET",
    Merge = "MERGE"
}

const createReducer =
    <TActionPayload>(
        constants: {
            readonly RESET: string;
            readonly SET: string;
            readonly MERGE: string;
        },
        initialState: TActionPayload
    ): Reducer<IValueState[keyof IValueState], TValueAction<TActionPayload>> =>
    (state: any = initialState, action: TValueAction<TActionPayload>) => {
        const { type, payload } = action;
        if (type === constants.RESET) {
            return { ...state, ...initialState };
        }

        if (type === constants.SET) {
            if (isArray(payload)) {
                return payload;
            }
            return { ...state, ...payload };
        }

        if (type === constants.MERGE) {
            if (isArray(payload)) {
                return [...state, ...(payload as Array<any>)];
            }
            const newState = merge({}, state, payload);
            return {
                ...newState
            };
        }

        return state;
    };

export default <TActionPayload>(
    namespace: keyof IValueState,
    initialState: TActionPayload
) => {
    const constants = createConstants(
        VALUE_STAGES,
        $ValueModuleName,
        namespace
    );

    const reducer = createReducer<TActionPayload>(constants, initialState);

    try {
        if (hasWindow() && window?.storeManager) {
            window?.storeManager.reducerManagers.value.add(namespace, reducer);
            window?.storeManager.dispatch({
                type: constants.SET,
                payload: initialState
            });
        }
    } catch (e) {
        console.log(`ERROR-VALUE::${namespace}`);
        console.error(e);
    }

    return {
        constants,
        actions: {
            clear: () => ({
                type: constants.RESET
            }),
            set: (payload: Partial<TActionPayload>) => ({
                type: constants.SET,
                payload
            }),
            update: (payload?: Partial<TActionPayload>) => ({
                type: constants.MERGE,
                payload
            })
        }
    };
};
